module.exports = __webpack_public_path__ + "media/fonts/Oricons-6a204f3bf590d0e2e96f2f195fea681c.woff2";